import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow,
    Typography,
    TablePagination
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {DatabaseIconHL7, DateIconHL7} from "../../../components/icons/icons";
import * as React from "react";
import NavigateBeforeSharpIcon from "@mui/icons-material/NavigateBeforeSharp";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AgyleAdminTableRow from "./table_row";
import makeStyles from "@mui/styles/makeStyles";
import {DbSlicesIcon} from "../../../components/icons/adminIcons";
import {AgyleNamedIcon} from "../../../components/icons/agyle";

const useStyles = makeStyles((theme) => ({
    clickable: {
        cursor: "pointer",
        color: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.primary.contrastText,
        }
    },
}));

function AgyleAdminTable(props){
    const classes = useStyles();
    const columnsWidths = props.columnsWidths;
    const [page, setPage] = React.useState(0);
    const [sortSend, setSortSend]= React.useState("!_createdDate");
    const [messages, setMessages] = React.useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);

    const pageSize = props.pageSize || 100;

    const getColumnWidth = column => (columnsWidths[column?.description]|| '256px');

    React.useEffect(()=>{
        if(props.records && props.records.length > 0){
            setMessages(props.records);
        } else {
            setMessages([]);
        }
    }, [props.records])

    const handleChangeNextPage = () => {
        setPage(page+1);
    };

    const handleChangePrevPage = () => {
        setPage(page-1);
    };

    const addRow = (row) => {
        //
    }

    const removeRow = (row) => {
        //
    }

    return (
        <React.Fragment>
            <TableContainer style={{maxWidth: "100%", ...props.style}}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead  key={"HEAD"}>
                        <TableRow>
                            {props.columns?.map((column,indexColumn) => {
                                return (
                                    <TableCell
                                        key={indexColumn + "_cell_header"}
                                        align={column.align}
                                        style={{
                                            wordBreak: "break-all",
                                            minWidth: column.minWidth,
                                            width: column.maxWidth || getColumnWidth(column),
                                            border: "1px solid #80808035",
                                        }}
                                    >
                                        <Grid container justifyContent="space-between">
                                            <Typography variant="subtitle2" color="textSecondary">
                                                {column.description}
                                            </Typography>
                                            {indexColumn === props.columns.length-1 && props.canManageColumns && <AgyleNamedIcon name={"dbSlices"} className={classes.clickable} onClick={props.openColumnManager}/>}
                                            {column.hasOwnProperty('icon') &&
                                                (<React.Fragment>
                                                    {column.icon}
                                                </React.Fragment>)}
                                        </Grid>
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {messages
                            .map((row, rowIndex) => {
                                return <React.Fragment key = {rowIndex+"div"}>
                                    <AgyleAdminTableRow columns = {props.columns}
                                                messagePath = {props.messagePath}
                                                row = {row} handleAddRow={addRow}
                                                rowIndex={rowIndex}
                                                handleRemoveRow={removeRow}/>
                                </React.Fragment>
                            })}
                    </TableBody>
                    {/*<TableFooter>*/}
                    {/*    <TableRow>*/}
                    {/*        <TableCell colSpan={props.columns.length} >*/}
                    {/*            Page: {page+1}*/}
                    {/*            <IconButton size="small"*/}
                    {/*                        disabled={page < 1}*/}
                    {/*                        onClick={handleChangePrevPage}>*/}
                    {/*                <NavigateBeforeSharpIcon fontSize="small"/>*/}
                    {/*            </IconButton>*/}
                    {/*            <IconButton size="small"*/}
                    {/*                        disabled={messages.length < pageSize-1}*/}
                    {/*                        onClick={handleChangeNextPage}>*/}
                    {/*                <NavigateNextIcon fontSize="small" />*/}
                    {/*            </IconButton>*/}
                    {/*        </TableCell>*/}
                    {/*    </TableRow>*/}
                    {/*</TableFooter>*/}
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[messages.length]}
                component="div"
                count={messages.length}
                rowsPerPage={messages.length}
                page={page}
                // onPageChange={handleChangePage}
                // onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </React.Fragment>
    )
}

export default AgyleAdminTable;